import * as React from 'react';

import { InviteContext } from '../context/InviteContext';

const { useContext } = React;

export const useInviteContext = () => useContext(InviteContext);
